import { MDBIcon } from 'mdb-react-ui-kit';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const RemoveToUser = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  async function removeThisUser() {
    props.setIsDeleteUser(true);
    props.onClose();

  }
  return (
    <>
      <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
        <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
        <span>{props?.supervisorFlag ? t("RemoveSupervisortxt") :  props?.smsGroupUser? t("RemoveSmsGroupUsertxt") : t("RemoveHuntUsertxt")}</span>   
      </div>
      <div>
        {/* <span className="phrecording">{props?.supervisorFlag ? t("RemoveSupervisortxt") : t("RemoveUsertxt")}</span> */}
      </div>

      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => { e.preventDefault(); removeThisUser() }}>
          {t("remove")}</button>
      </div>

      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => {
          e.preventDefault();
          removeThisUser();
        }}>{t("remove")}</MDBBtn>
      </MDBModalFooter> */}
    </>
  )
});

export default RemoveToUser;
